import React, { useContext, useEffect, useState } from 'react';
import './ProfilePopUp.css';
import { ERROR_MESSAGES } from '../../Componant/GlobalMessages';
import { LoaderContext, AuthContext } from '../../Context/ContextProvider';
import {
  change_password,
  get_org_details,
  get_org_members,
  update_org_details,
  remove_org_member,
  add_org_member,
} from '../../Services/Dashboard/DashboardApi';
import SuccessModel from '../../Componant/SuccessModel';
import ImageUploadEditModal from '../../Componant/ImageUploadEditModal ';
import ConfirmationModal from '../../Componant/ConfirmationModal';
import { get_list_filter_signup, get_student_delete } from '../../Services/Student/StudentApi';
import editIcon from '../../Assets/Images/editIcon.png';
import ViewImagePopup from '../../Componant/ViewImage';
import { isGoogleSSOUser } from '../../utils/authProvider';

const normalizeText = value => (typeof value === 'string' ? value.trim().toLowerCase() : '');
const SUPPORT_EMAIL = 'support@seekjobs.ai';
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

const getSuperAdminLabel = superAdminValue => {
  if (typeof superAdminValue === 'string') return superAdminValue;
  if (superAdminValue && typeof superAdminValue === 'object') {
    return superAdminValue.name || superAdminValue.full_name || superAdminValue.email || '';
  }
  return '';
};

const getSuperAdminEmail = superAdminValue => {
  if (typeof superAdminValue === 'string') {
    return emailPattern.test(superAdminValue.trim()) ? superAdminValue.trim() : '';
  }
  if (superAdminValue && typeof superAdminValue === 'object') {
    return superAdminValue.email || superAdminValue.admin_email || superAdminValue.super_admin_email || '';
  }
  return '';
};

const hasSuperAdminAccess = payload => {
  if (!payload || typeof payload !== 'object') return false;
  return Boolean(
    payload.is_super_admin ||
      payload.isSuperAdmin ||
      payload.role === 'super_admin' ||
      payload?.organization?.is_super_admin ||
      payload?.organization?.isSuperAdmin ||
      payload?.organization?.role === 'super_admin' ||
      payload?.organization?.admin_role === 'super_admin',
  );
};

const ProfileAndSettingPopUp = ({ isOpen, onClose, Tab }) => {
  const [activeTab, setActiveTab] = useState(Tab || 'profile');
  const [requireMessage, setRequireMessage] = useState(false);
  const [Error, setError] = useState('');
  const [isAddUpdateDone, setAddUpdateDone] = useState(false);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
  const [IsViewImage, setIsViewImage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [image, setImage] = useState(null);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, isProfileUpdate, setIsProfileUpdate } = useContext(AuthContext);
  const isSSOUser = isGoogleSSOUser(authDetails);
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [cities, setCities] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isRemoveAdminConfirmOpen, setRemoveAdminConfirmOpen] = useState(false);
  const [isErrorPopupOpen, setIsErrorPopupOpen] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState('');
  const [memberToRemoveId, setMemberToRemoveId] = useState(null);
  const [superAdmin, setSuperAdmin] = useState(null);
  const [superAdminEmail, setSuperAdminEmail] = useState('');
  const [canManageAdminUsers, setCanManageAdminUsers] = useState(hasSuperAdminAccess(authDetails));
  const [isCurrentUserSuperAdmin, setIsCurrentUserSuperAdmin] = useState(false);

  useEffect(() => {
    setCanManageAdminUsers(hasSuperAdminAccess(authDetails));
  }, [authDetails]);

  const [settingsView, setSettingsView] = useState('initial');
  const [members, setMembers] = useState([]);
  const [newAdmin, setNewAdmin] = useState({
    fullName: '',
    email: '',
  });

  const [profileData, setProfileData] = useState({
    fullName: null,
    email: null,
    phone: null,
    location: null,
    thumbnail: '',
    univercity: null,
    countryCodes: null,
  });
  const [allLocations, setAllLocations] = useState([]);
  const [matchedLocations, setMatchedLocations] = useState([]);
  const [activeLocationIndex, setActiveLocationIndex] = useState(null);
  const [highlightedLocationIndex, setHighlightedLocationIndex] = useState(-1);

  const handleLocationSearch = (value, index) => {
    setActiveLocationIndex(index);
    setHighlightedLocationIndex(-1);
    if (!value || !value.trim()) {
      setMatchedLocations([]);
      return;
    }
    const searchTerm = value.toLowerCase().replace(/\s+/g, ' ').trim();
    const filtered = allLocations
      .filter(loc => {
        const label = loc.label.toLowerCase().replace(/\s+/g, ' ').trim();
        return label.includes(searchTerm);
      })
      .slice(0, 50);
    setMatchedLocations(filtered);
  };

  const selectLocation = loc => {
    setProfileData(prev => ({ ...prev, location: loc.label }));
    setMatchedLocations([]);
    setActiveLocationIndex(null);
  };
  const isKnownLocationLabel = value => {
    const normalizedValue = (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    return !!normalizedValue && allLocations.some(loc => loc.label.toLowerCase().replace(/\s+/g, ' ').trim() === normalizedValue);
  };
  const handleLocationBlur = () => {
    setTimeout(() => {
      setMatchedLocations([]);
      setActiveLocationIndex(null);
      if (profileData.location && !isKnownLocationLabel(profileData.location)) {
        setProfileData(prev => ({ ...prev, location: '' }));
      }
    }, 200);
  };

  const handleLocationKeyDown = e => {
    if (matchedLocations.length === 0) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedLocationIndex(prev => (prev < matchedLocations.length - 1 ? prev + 1 : prev));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedLocationIndex(prev => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (highlightedLocationIndex >= 0 && highlightedLocationIndex < matchedLocations.length) {
        selectLocation(matchedLocations[highlightedLocationIndex]);
      }
    }
  };
  const countryCodes = [
    { name: 'Afghanistan', code: '+93' },
    { name: 'Albania', code: '+355' },
    { name: 'Algeria', code: '+213' },
    { name: 'American Samoa', code: '-683' },
    { name: 'Andorra', code: '+376' },
    { name: 'Angola', code: '+244' },
    { name: 'Anguilla', code: '-263' },
    { name: 'Antigua and Barbuda', code: '-267' },
    { name: 'Argentina', code: '+54' },
    { name: 'Armenia', code: '+374' },
    { name: 'Aruba', code: '+297' },
    { name: 'Australia', code: '+61' },
    { name: 'Austria', code: '+43' },
    { name: 'Azerbaijan', code: '+994' },
    { name: 'Bahamas', code: '-241' },
    { name: 'Bahrain', code: '+973' },
    { name: 'Bangladesh', code: '+880' },
    { name: 'Barbados', code: '-245' },
    { name: 'Belarus', code: '+375' },
    { name: 'Belgium', code: '+32' },
    { name: 'Belize', code: '+501' },
    { name: 'Benin', code: '+229' },
    { name: 'Bermuda', code: '-440' },
    { name: 'Bhutan', code: '+975' },
    { name: 'Bolivia', code: '+591' },
    { name: 'Bosnia and Herzegovina', code: '+387' },
    { name: 'Botswana', code: '+267' },
    { name: 'Brazil', code: '+55' },
    { name: 'British Virgin Islands', code: '-283' },
    { name: 'Brunei', code: '+673' },
    { name: 'Bulgaria', code: '+359' },
    { name: 'Burkina Faso', code: '+226' },
    { name: 'Burundi', code: '+257' },
    { name: 'Cambodia', code: '+855' },
    { name: 'Cameroon', code: '+237' },
    { name: 'Canada', code: "+1'" },
    { name: 'Cape Verde', code: '+238' },
    { name: 'Cayman Islands', code: '-344' },
    { name: 'Central African Republic', code: '+236' },
    { name: 'Chad', code: '+235' },
    { name: 'Chile', code: '+56' },
    { name: 'China', code: '+86' },
    { name: 'Colombia', code: '+57' },
    { name: 'Comoros', code: '+269' },
    { name: 'Congo', code: '+242' },
    { name: 'Cook Islands', code: '+682' },
    { name: 'Costa Rica', code: '+506' },
    { name: 'Croatia', code: '+385' },
    { name: 'Cuba', code: '+53' },
    { name: 'Curaçao', code: '+599' },
    { name: 'Cyprus', code: '+357' },
    { name: 'Czech Republic (Czechia)', code: '+420' },
    { name: 'Denmark', code: '+45' },
    { name: 'Djibouti', code: '+253' },
    { name: 'Dominica', code: '-766' },
    { name: 'Dominican Republic', code: '+1-809, +1-829, +1-849' },
    { name: 'DR Congo', code: '+243' },
    { name: 'East Timor', code: '+670' },
    { name: 'Ecuador', code: '+593' },
    { name: 'Egypt', code: '+20' },
    { name: 'El Salvador', code: '+503' },
    { name: 'Equatorial Guinea', code: '+240' },
    { name: 'Eritrea', code: '+291' },
    { name: 'Estonia', code: '+372' },
    { name: 'Eswatini', code: '+268' },
    { name: 'Ethiopia', code: '+251' },
    { name: 'Faroe Islands', code: '+298' },
    { name: 'Fiji', code: '+679' },
    { name: 'Finland', code: '+358' },
    { name: 'France', code: '+33' },
    { name: 'French Polynesia', code: '+689' },
    { name: 'Gabon', code: '+241' },
    { name: 'Gambia', code: '+220' },
    { name: 'Georgia', code: '+995' },
    { name: 'Germany', code: '+49' },
    { name: 'Ghana', code: '+233' },
    { name: 'Gibraltar', code: '+350' },
    { name: 'Greece', code: '+30' },
    { name: 'Greenland', code: '+299' },
    { name: 'Grenada', code: '-472' },
    { name: 'Guam', code: '-670' },
    { name: 'Guatemala', code: '+502' },
    { name: 'Guinea', code: '+224' },
    { name: 'Guinea-Bissau', code: '+245' },
    { name: 'Guyana', code: '+592' },
    { name: 'Haiti', code: '+509' },
    { name: 'Honduras', code: '+504' },
    { name: 'Hong Kong', code: '+852' },
    { name: 'Hungary', code: '+36' },
    { name: 'Iceland', code: '+354' },
    { name: 'India', code: '+91' },
    { name: 'Indonesia', code: '+62' },
    { name: 'Iran', code: '+98' },
    { name: 'Iraq', code: '+964' },
    { name: 'Ireland', code: '+353' },
    { name: 'Israel', code: '+972' },
    { name: 'Italy', code: '+39' },
    { name: 'Jamaica', code: '-875' },
    { name: 'Japan', code: '+81' },
    { name: 'Jordan', code: '+962' },
    { name: 'Kazakhstan', code: '+7' },
    { name: 'Kenya', code: '+254' },
    { name: 'Kiribati', code: '+686' },
    { name: 'North Korea', code: '+850' },
    { name: 'South Korea', code: '+82' },
    { name: 'Kuwait', code: '+965' },
    { name: 'Kyrgyzstan', code: '+996' },
    { name: 'Laos', code: '+856' },
    { name: 'Latvia', code: '+371' },
    { name: 'Lebanon', code: '+961' },
    { name: 'Lesotho', code: '+266' },
    { name: 'Liberia', code: '+231' },
    { name: 'Libya', code: '+218' },
    { name: 'Liechtenstein', code: '+423' },
    { name: 'Lithuania', code: '+370' },
    { name: 'Luxembourg', code: '+352' },
    { name: 'Macao', code: '+853' },
    { name: 'Madagascar', code: '+261' },
    { name: 'Malawi', code: '+265' },
    { name: 'Malaysia', code: '+60' },
    { name: 'Maldives', code: '+960' },
    { name: 'Mali', code: '+223' },
    { name: 'Malta', code: '+356' },
    { name: 'Marshall Islands', code: '+692' },
    { name: 'Mauritania', code: '+222' },
    { name: 'Mauritius', code: '+230' },
    { name: 'Mexico', code: '+52' },
    { name: 'Micronesia', code: '+691' },
    { name: 'Moldova', code: '+373' },
    { name: 'Monaco', code: '+377' },
    { name: 'Mongolia', code: '+976' },
    { name: 'Montenegro', code: '+382' },
    { name: 'Montserrat', code: '-663' },
    { name: 'Morocco', code: '+212' },
    { name: 'Mozambique', code: '+258' },
    { name: 'Myanmar', code: '+95' },
    { name: 'Namibia', code: '+264' },
    { name: 'Nauru', code: '+674' },
    { name: 'Nepal', code: '+977' },
    { name: 'Netherlands', code: '+31' },
    { name: 'New Caledonia', code: '+687' },
    { name: 'New Zealand', code: '+64' },
    { name: 'Nicaragua', code: '+505' },
    { name: 'Niger', code: '+227' },
    { name: 'Nigeria', code: '+234' },
    { name: 'Niue', code: '+683' },
    { name: 'North Macedonia', code: '+389' },
    { name: 'Norway', code: '+47' },
    { name: 'Oman', code: '+968' },
    { name: 'Pakistan', code: '+92' },
    { name: 'Palau', code: '+680' },
    { name: 'Palestine', code: '+970' },
    { name: 'Panama', code: '+507' },
    { name: 'Papua New Guinea', code: '+675' },
    { name: 'Paraguay', code: '+595' },
    { name: 'Peru', code: '+51' },
    { name: 'Philippines', code: '+63' },
    { name: 'Poland', code: '+48' },
    { name: 'Portugal', code: '+351' },
    { name: 'Puerto Rico', code: '+1-787, +1-939' },
    { name: 'Qatar', code: '+974' },
    { name: 'Romania', code: '+40' },
    { name: 'Russia', code: '+7' },
    { name: 'Rwanda', code: '+250' },
    { name: 'Saint Kitts and Nevis', code: '-868' },
    { name: 'Saint Lucia', code: '-757' },
    { name: 'Saint Vincent and the Grenadines', code: '-783' },
    { name: 'Samoa', code: '+685' },
    { name: 'San Marino', code: '+378' },
    { name: 'Sao Tome and Principe', code: '+239' },
    { name: 'Saudi Arabia', code: '+966' },
    { name: 'Senegal', code: '+221' },
    { name: 'Serbia', code: '+381' },
    { name: 'Seychelles', code: '+248' },
    { name: 'Sierra Leone', code: '+232' },
    { name: 'Singapore', code: '+65' },
    { name: 'Sint Maarten', code: '-720' },
    { name: 'Slovakia', code: '+421' },
    { name: 'Slovenia', code: '+386' },
    { name: 'Solomon Islands', code: '+677' },
    { name: 'Somalia', code: '+252' },
    { name: 'South Africa', code: '+27' },
    { name: 'South Sudan', code: '+211' },
    { name: 'Spain', code: '+34' },
    { name: 'Sri Lanka', code: '+94' },
    { name: 'Sudan', code: '+249' },
    { name: 'Suriname', code: '+597' },
    { name: 'Sweden', code: '+46' },
    { name: 'Switzerland', code: '+41' },
    { name: 'Syria', code: '+963' },
    { name: 'Taiwan', code: '+886' },
    { name: 'Tajikistan', code: '+992' },
    { name: 'Tanzania', code: '+255' },
    { name: 'Thailand', code: '+66' },
    { name: 'Togo', code: '+228' },
    { name: 'Tonga', code: '+676' },
    { name: 'Trinidad and Tobago', code: '-867' },
    { name: 'Tunisia', code: '+216' },
    { name: 'Turkey', code: '+90' },
    { name: 'Turkmenistan', code: '+993' },
    { name: 'Tuvalu', code: '+688' },
    { name: 'Uganda', code: '+256' },
    { name: 'Ukraine', code: '+380' },
    { name: 'United Arab Emirates', code: '+971' },
    { name: 'United Kingdom', code: '+44' },
    { name: 'United States', code: '+1' },
    { name: 'Uruguay', code: '+598' },
    { name: 'Uzbekistan', code: '+998' },
    { name: 'Vanuatu', code: '+678' },
    { name: 'Vatican City', code: '+379' },
    { name: 'Venezuela', code: '+58' },
    { name: 'Vietnam', code: '+84' },
    { name: 'Yemen', code: '+967' },
    { name: 'Zambia', code: '+260' },
    { name: 'Zimbabwe', code: '+263' },
  ];

  const defaultCountry = countryCodes.find(country => country.code === '+1') || countryCodes[0];
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry); // Define setSelectedCountry here

  const [profileStaticData, setProfileStaticData] = useState({
    fullName: null,
    email: null,
    phone: null,
    location: null,
    thumbnail: null,
    univercity: null,
  });

  const [settingsData, setSettingsData] = useState({
    password: '',
    newPassword: '',
    retypePassword: '',
  });

  const [showPassword, setShowPassword] = useState({
    password: false,
    newPassword: false,
    retypePassword: false,
  });

  const [errors, setErrors] = useState({});
  const [passwordStrength, setPasswordStrength] = useState('');
  const deactivateAccountMessage = isCurrentUserSuperAdmin
    ? `Please contact SeekJobs support at ${SUPPORT_EMAIL} to deactivate your Super Admin account.`
    : `Please contact your University's Super Admin${
        superAdminEmail ? ` at ${superAdminEmail}` : superAdmin ? ` (${superAdmin})` : ''
      } to deactivate your account.`;
  const deactivateAccountSubMessage = isCurrentUserSuperAdmin
    ? 'Super Admin accounts cannot be deactivated from inside Settings.'
    : 'They can use Settings > Manage Admin Users > Remove Admin Access.';

  useEffect(() => {
    if (isOpen) {
      setActiveTab(Tab || 'profile');
    }
  }, [isOpen, Tab]);

  useEffect(() => {
    const fetchFiltersData = async () => {
      try {
        const response = await get_list_filter_signup();
        const locations = [];
        const processItem = item => {
          if (item.name && item.code) {
            locations.push({ label: `${item.name} (${item.code})`, value: item.code });
            (item.cities || []).forEach(city => {
              locations.push({ label: `${city}, ${item.code}`, value: `${city}, ${item.code}` });
            });
          }
        };
        if (response && response.us_state_city) {
          response.us_state_city.forEach(item => {
            if (item.states) item.states.forEach(state => processItem(state));
            else processItem(item);
          });
        } else if (Array.isArray(response)) {
          response.forEach(item => processItem(item));
        } else if (response && Array.isArray(response.data)) {
          response.data.forEach(item => processItem(item));
        }
        setAllLocations(locations);
      } catch (error) {
        console.error('Failed to fetch location filters:', error);
      }
    };

    fetchFiltersData();
  }, []);

  useEffect(() => {
    handleGetOrganisationDetails();
    setAddUpdateDone(false);
  }, [isOpen, isAddUpdateDone]);

  useEffect(() => {
    if (!isOpen) return;

    // Keep organization contact fields locked until the API confirms Super Admin access.
    setIsCurrentUserSuperAdmin(false);
    setCanManageAdminUsers(false);
    handleGetMembers({ silent: true });
  }, [isOpen]);

  const handleGetMembers = async ({ silent = false } = {}) => {
    if (!silent) {
      setLoader(true);
    }
    setError('');
    try {
      const response = await get_org_members();
      if (response && !response.code?.includes('ERR')) {
        const superAdminLabel = getSuperAdminLabel(response.super_admin);
        const resolvedSuperAdminEmail = getSuperAdminEmail(response.super_admin);
        const currentUserEmail = normalizeText(
          response?.current_user_email ||
            authDetails?.email ||
            authDetails?.user?.email ||
            authDetails?.organization?.email ||
            profileStaticData.email,
        );
        const currentUserName = normalizeText(
          response?.current_user_name ||
            authDetails?.name ||
            authDetails?.full_name ||
            authDetails?.organization?.admin_name ||
            profileStaticData.fullName,
        );
        const normalizedSuperAdmin = normalizeText(superAdminLabel);
        const hasExplicitSuperAdminFlag = typeof response?.is_super_admin === 'boolean';
        const currentUserSuperAdminFlag = hasExplicitSuperAdminFlag
          ? response.is_super_admin
          : Boolean(response?.current_user_is_super_admin || response?.current_user?.is_super_admin);
        const authSuperAdminFlag = hasSuperAdminAccess(authDetails);

        const fallbackSuperAdminAccess = Boolean(
          authSuperAdminFlag ||
            (normalizedSuperAdmin && (normalizedSuperAdmin === currentUserEmail || normalizedSuperAdmin === currentUserName)),
        );
        const resolvedCurrentUserIsSuperAdmin = hasExplicitSuperAdminFlag
          ? currentUserSuperAdminFlag
          : fallbackSuperAdminAccess;

        setCanManageAdminUsers(resolvedCurrentUserIsSuperAdmin);
        setIsCurrentUserSuperAdmin(resolvedCurrentUserIsSuperAdmin);
        setMembers(response.members || []);
        setSuperAdmin(superAdminLabel || null);
        setSuperAdminEmail(resolvedSuperAdminEmail);
      } else {
        if (!silent) {
          setError(response?.response?.data?.message || 'Failed to fetch admin members.');
        }
        setMembers([]);
        setSuperAdmin(null);
        setSuperAdminEmail('');
        setCanManageAdminUsers(hasSuperAdminAccess(authDetails));
        setIsCurrentUserSuperAdmin(false);
      }
    } catch (err) {
      if (!silent) {
        setError('Failed to fetch admin members.');
      }
      setMembers([]);
      setSuperAdmin(null);
      setSuperAdminEmail('');
      setCanManageAdminUsers(hasSuperAdminAccess(authDetails));
      setIsCurrentUserSuperAdmin(false);
    } finally {
      if (!silent) {
        setLoader(false);
      }
    }
  };

  const handleNewAdminChange = e => {
    const { name, value } = e.target;
    setNewAdmin(prev => ({ ...prev, [name]: value }));
    if (errors.newAdminFullName && name === 'fullName') {
      setErrors(prev => ({ ...prev, newAdminFullName: null }));
    }
    if (errors.newAdminEmail && name === 'email') {
      setErrors(prev => ({ ...prev, newAdminEmail: null }));
    }
  };

  const handleAddAdmin = async () => {
    const newErrors = {};
    if (!newAdmin.fullName.trim()) {
      newErrors.newAdminFullName = 'Full Name is required.';
    }
    if (!newAdmin.email.trim()) {
      newErrors.newAdminEmail = 'Email is required.';
    } else if (!validateEmail(newAdmin.email)) {
      newErrors.newAdminEmail = 'Please enter a valid email address.';
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setLoader(true);
    setError('');
    try {
      const payload = {
        name: newAdmin.fullName,
        email: newAdmin.email,
      };
      const response = await add_org_member(payload);
      if (response && !response.code?.includes('ERR')) {
        setSuccessMessage('Admin added successfully!');
        setIsSuccessOpen(true);
        setNewAdmin({ fullName: '', email: '' }); // Reset form
        handleGetMembers(); // Refresh the list
      } else {
        setErrorPopupMessage(response?.response?.data?.error || response?.response?.data?.message || 'Failed to add new admin.');
        setIsErrorPopupOpen(true);
      }
    } catch (err) {
      setErrorPopupMessage('An error occurred while adding the admin.');
      setIsErrorPopupOpen(true);
    } finally {
      setLoader(false);
    }
  };

  const handleRemoveAdmin = memberId => {
    setMemberToRemoveId(memberId);
    setRemoveAdminConfirmOpen(true);
  };

  const handleConfirmRemoveAdmin = async () => {
    if (!memberToRemoveId) return;

    setLoader(true);
    setError('');
    try {
      const response = await remove_org_member(memberToRemoveId);
      if (response && !response.code?.includes('ERR')) {
        setSuccessMessage('Admin removed successfully!');
        setIsSuccessOpen(true);
        handleGetMembers(); // Refresh the list
      } else {
        setErrorPopupMessage(response?.response?.data?.error || response?.response?.data?.message || 'Failed to remove admin.');
        setIsErrorPopupOpen(true);
      }
    } catch (err) {
      setErrorPopupMessage('An error occurred while removing the admin.');
      setIsErrorPopupOpen(true);
    } finally {
      setLoader(false);
      setRemoveAdminConfirmOpen(false);
      setMemberToRemoveId(null);
    }
  };

  const validateEmail = email => {
    // Basic regex for email validation
    return emailPattern.test(email);
  };

  const validatePhoneNumber = (phone, countryCode) => {
    // Find the selected country data
    const selectedCountry = countryCodes.find(country => country.code === countryCode);
    if (!selectedCountry) return false;
    // Allow only digits
    const phoneRegex = /^[0-9]*$/;
    // Validate length based on country, fallback to minimum 6 digits if no length specified
    const expectedLength = selectedCountry.length || 6;
    const isValidLength = phone.length === expectedLength;
    return phoneRegex.test(phone) && isValidLength;
  };

  const handleGetOrganisationDetails = async () => {
    setLoader(true);
    try {
      const response = await get_org_details();
      if (!response?.code?.includes('ERR')) {
        setLoader(false);
        const formattedValue = response.phone?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        setProfileData(prev => ({
          ...prev,
          fullName: response.admin_name,
          email: response.email,
          phone: formattedValue,
          location: response.location,
          thumbnail: response.thumbnail,
          univercity: response.name,
        }));
        setProfileStaticData({
          ...profileStaticData,
          fullName: response.admin_name,
          email: response.email,
          phone: formattedValue,
          location: response.location,
          thumbnail: response.thumbnail,
          univercity: response.name,
        });
      } else {
        setLoader(false);
        // Handle server-side errors
        setError(response?.response?.data?.error);
      }
    } catch (err) {
      setLoader(false);
      setError('Something went wrong. Please try again.');
    }
  };

  if (!isOpen) return null;

  const handleTabClick = tab => {
    setActiveTab(tab);
    setError('');
    if (tab !== 'settings') {
      setSettingsView('initial');
    }
  };

  const handleProfileChange = e => {
    const { name, value } = e.target;

    // Handle phone number formatting
    if (name === 'phone') {
      // Remove all non-digit characters
      const numericValue = value.replace(/\D/g, '').slice(0, 10); // Limit to 10 digits

      // Format the phone number as 111-111-1111
      const formattedValue = numericValue.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

      setProfileData(prev => ({
        ...prev,
        phone: formattedValue,
      }));
    } else if (name === 'location') {
      const filteredValue = value.replace(/[0-9]/g, '');

      setProfileData(prev => ({
        ...prev,
        [name]: filteredValue,
      }));
    } else if (name === 'fullName') {
      // Validate Full Name to allow only letters and spaces (no numbers or dots)
      const nameRegex = /^[A-Za-z\s]*$/; // Regex to allow only letters and spaces
      if (nameRegex.test(value) || value === '') {
        setProfileData(prev => ({
          ...prev,
          [name]: value,
        }));
      }
    } else {
      // Handle other fields
      setProfileData(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const toggleVisibility = field => {
    setShowPassword(prev => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSettingsChange = e => {
    const { name, value } = e.target;

    setSettingsData(prev => ({
      ...prev,
      [name]: value,
    }));
    setError('');
    // Clear the error for this field if it's now valid
    setErrors(prevErrors => {
      const updatedErrors = { ...prevErrors };

      // Remove "required" error if input is not empty
      if (value.trim() !== '') {
        delete updatedErrors[name];
      }

      // Special case: validate `newPassword` live
      if (name === 'newPassword') {
        if (value.length >= 8 && /[A-Z]/.test(value) && /[a-z]/.test(value) && /\W/.test(value)) {
          delete updatedErrors[name];
        }
      }

      return updatedErrors;
    });

    // Optional: Update password strength live
    if (name === 'newPassword') {
      setPasswordStrength(getPasswordStrength(value));
    }
  };

  const handleUpdatePassword = async () => {
    const { password, newPassword, retypePassword } = settingsData;
    const newErrors = {};

    // Validation: required fields
    if (!password) newErrors.password = 'Current password is required.';
    if (!newPassword) newErrors.newPassword = 'New password is required.';
    if (!retypePassword) newErrors.retypePassword = 'Please retype new password.';

    // Validation: length
    if (newPassword && newPassword.length < 8) {
      newErrors.newPassword = 'Password must be at least 8 characters.';
    }

    // Validation: must differ from current password
    if (newPassword && password && newPassword === password) {
      newErrors.newPassword = 'New password must be different from current.';
    }

    // Validation: password match
    if (newPassword && retypePassword && newPassword !== retypePassword) {
      newErrors.retypePassword = 'Passwords do not match.';
    }

    // Specific password rule validations (only if no previous newPassword error)
    if (newPassword && !newErrors.newPassword) {
      if (!/[A-Z]/.test(newPassword)) {
        newErrors.newPassword = 'Password must contain at least one uppercase letter.';
      } else if (!/[a-z]/.test(newPassword)) {
        newErrors.newPassword = 'Password must contain at least one lowercase letter.';
      } else if (!/\W/.test(newPassword)) {
        newErrors.newPassword = 'Password must contain at least one special character.';
      }
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      // ✅ Proceed with update (API call or further logic)
      setLoader(true);
      const data = await change_password({
        old_password: settingsData.password,
        new_password: settingsData.newPassword,
      });
      if (!data?.code?.includes('ERR')) {
        setLoader(false);
        setIsSuccessOpen(true);
        setSettingsData({
          password: '',
          newPassword: '',
          retypePassword: '',
        });
      } else {
        setLoader(false);
        setError(data?.response?.data?.message || 'Something went wrong. Please try again.');
      }
    }
  };
  const getPasswordStrength = value => {
    let strength = 0;
    if (value.length >= 8) strength++;
    if (/[A-Z]/.test(value)) strength++;
    if (/[a-z]/.test(value)) strength++;
    if (/\W/.test(value)) strength++;

    if (strength <= 2) return 'Weak';
    if (strength === 3) return 'Fair';
    if (strength === 4) return 'Strong';
  };

  const getStrengthColor = strength => {
    switch (strength) {
      case 'Weak':
        return '#dc3545'; // red
      case 'Fair':
        return '#ffc107'; // yellow/orange
      case 'Strong':
        return '#28a745'; // green
      default:
        return '#6c757d';
    }
  };

  const getStrengthWidth = strength => {
    switch (strength) {
      case 'Weak':
        return '33%';
      case 'Fair':
        return '66%';
      case 'Strong':
        return '100%';
      default:
        return '0%';
    }
  };
  const handleSave = async () => {
    if (
      profileData.fullName === undefined ||
      profileData.fullName === null ||
      profileData.fullName === '' ||
      profileData.email === undefined ||
      profileData.email === null ||
      profileData.email === '' ||
      (isCurrentUserSuperAdmin &&
        (profileData.phone === undefined ||
          profileData.phone === null ||
          profileData.phone === '' ||
          !/^\d{10}$/.test(profileData.phone.replace(/\D/g, '')) ||
          profileData.location === undefined ||
          profileData.location === null ||
          profileData.location === ''))
    ) {
      setRequireMessage(true);
      return;
    }
    setLoader(true);
    const updatePayload = {
      name: profileData.univercity, // optional
      admin_name: profileData.fullName, // optional
    };

    if (isCurrentUserSuperAdmin) {
      updatePayload.phone = profileData.phone;
      updatePayload.location = profileData.location;
    }

    const data = await update_org_details(updatePayload);

    if (!data?.code?.includes('ERR')) {
      setLoader(false);
      setIsSuccessOpen(true);
    } else {
      setLoader(false);
      setError(data?.response?.data?.message || 'Something went wrong. Please try again.');
    }
  };

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
          padding: '0px',
        }}
        onClick={onClose}
      />
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
          zIndex: 1001,
          maxWidth: '500px',
          width: '90%',
        }}
        onClick={e => e.stopPropagation()}
      >
        <div className="container2">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingBottom: '10px' }}>
            <h4 style={{ margin: 0, fontWeight: 600, fontSize: '20px' }}>Profile & Settings</h4>
            <button
              onClick={onClose}
              style={{
                background: 'transparent',
                border: 'none',
                fontSize: '28px',
                cursor: 'pointer',
                color: '#555',
                padding: '0',
                lineHeight: '1',
              }}
            >
              &times;
            </button>
          </div>
          <div className="profileBtn-groupPropfile" style={{ marginTop: '10px' }}>
            <button className={`profileBtn ${activeTab === 'profile' ? 'active' : ''}`} onClick={() => handleTabClick('profile')}>
              Profile
            </button>
            <button className={`profileBtn ${activeTab === 'settings' ? 'active' : ''}`} onClick={() => handleTabClick('settings')}>
              Settings
            </button>
          </div>

          <div id="parent">
            {activeTab === 'profile' && (
              <div className="box a active" style={{ margin: '-16px' }}>
                <div className="profile-header">
                  <div
                    style={{
                      position: 'relative',
                      display: 'inline-block',
                      marginBottom: '15px',
                    }}
                  >
                    <img
                      onClick={() => {
                        setImage(profileData.thumbnail);
                        setIsViewImage(true);
                      }}
                      src={`${profileData.thumbnail}?t=${Date.now()}`}
                      alt="Profile"
                      className="profile-img"
                      style={{
                        width: '85px',
                        height: '85px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                    />
                    <span
                      className="profile-edit-icon"
                      onClick={() => {
                        setImage(profileData.thumbnail);
                        setIsImagePopupOpen(true);
                        setIsViewImage(false);
                      }}
                    >
                      {/* <i
                        className="fa-solid fa-pen"
                        style={{ fontSize: "12px", color: "#555", margin: 0, padding: 0 }}
                      ></i> */}
                      <img src={editIcon}></img>
                    </span>
                  </div>
                  <div className="profile-info">
                    <h2>{profileStaticData.univercity}</h2>
                    <p className="profile-info">{profileStaticData.fullName}</p>
                    <p className="university">{profileStaticData.email}</p>
                  </div>
                </div>
                <div className="profile-form">
                  {[
                    { label: 'Full Name', name: 'fullName' },
                    { label: 'Email Address', name: 'email' },
                    { label: 'Phone', name: 'phone' },
                  ].map((field, index) => (
                    <div key={index}>
                      <div className="form-group">
                        <label>{field.label}</label>
                      </div>
                      <div
                        className="form-field"
                        style={{
                          display: 'flex',
                          width: '100%',
                          flexDirection: 'row',
                        }}
                      >
                        {field.name === 'phone' ? (
                          <>
                            <div
                              className="form-field"
                              style={{
                                display: 'flex',
                                width: '100%',
                                flexDirection: 'row',
                              }}
                            >
                              <select
                                value={profileData.countryCode || '+1'}
                                disabled={!isCurrentUserSuperAdmin}
                                onChange={e =>
                                  handleProfileChange({
                                    target: {
                                      name: 'countryCode',
                                      value: e.target.value,
                                    },
                                  })
                                }
                                style={{
                                  width: '104%',
                                  minWidth: '80px',
                                  border: '1px solid #ccc',
                                  borderRight: 'none',
                                  borderRadius: '4px 0 0 4px',
                                  padding: '5px',
                                  height: '38px',
                                  backgroundColor: isCurrentUserSuperAdmin ? '#fff' : '#f8f9fa',
                                  cursor: isCurrentUserSuperAdmin ? 'pointer' : 'not-allowed',
                                }}
                              >
                                {countryCodes.map(country => (
                                  <option key={country.code} value={country.code}>
                                    {country.name} ({country.code})
                                  </option>
                                ))}
                              </select>
                            </div>
                            <input
                              type="text"
                              name="phone"
                              value={profileData.phone}
                              maxLength={12} // 10 digits + 2 dashes
                              readOnly={!isCurrentUserSuperAdmin}
                              onChange={handleProfileChange}
                              placeholder="Enter phone number"
                              style={{
                                padding: '8px',
                                backgroundColor: isCurrentUserSuperAdmin ? '#fff' : '#f8f9fa',
                                cursor: isCurrentUserSuperAdmin ? 'text' : 'not-allowed',
                              }}
                            />
                          </>
                        ) : (
                          <input
                            type="text"
                            name={field.name}
                            placeholder={field.name === 'fullName' ? 'Enter full name' : 'Enter location name'}
                            value={profileData[field.name]}
                            readOnly={field.name === 'email'}
                            onChange={handleProfileChange}
                            style={{
                              width: '100%',
                              border: '1px solid #ccc',
                              borderRadius: '4px',
                              padding: '8px',
                              height: '38px',
                              backgroundColor: field.name === 'email' ? '#f8f9fa' : '#fff',
                              cursor: field.name === 'email' ? 'not-allowed' : 'text',
                            }}
                          />
                        )}
                      </div>
                      {requireMessage &&
                        (field.name === 'phone' && !isCurrentUserSuperAdmin ? null : !profileData[field.name] ? (
                          <span className="validation">{ERROR_MESSAGES}</span>
                        ) : field.name === 'phone' && !/^\d{10}$/.test(profileData.phone.replace(/\D/g, '')) ? (
                          <span className="validation">Phone number must be exactly 10 digits</span>
                        ) : null)}

                      {errors[field.name] && <span className="validation">{errors[field.name]}</span>}
                    </div>
                  ))}

                  {/* Location Input Field */}
                  <div className="form-group">
                    <label>Location</label>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      width: '100%',
                      flexDirection: 'row',
                      marginTop: '-7px',
                      position: 'relative',
                    }}
                    className="form-field"
                  >
                    <input
                      type="text"
                      name="location"
                      placeholder="City, State, United States"
                      value={profileData.location || ''}
                      readOnly={!isCurrentUserSuperAdmin}
                      onBlur={isCurrentUserSuperAdmin ? handleLocationBlur : undefined}
                      onKeyDown={isCurrentUserSuperAdmin ? handleLocationKeyDown : undefined}
                      onChange={e => {
                        if (!isCurrentUserSuperAdmin) return;
                        const val = e.target.value.replace(/[0-9]/g, '');
                        handleProfileChange({ target: { name: 'location', value: val } });
                        handleLocationSearch(val, 'mainProfile');
                      }}
                      style={{
                        width: '100%',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '8px',
                        height: '38px',
                        backgroundColor: isCurrentUserSuperAdmin ? '#fff' : '#f8f9fa',
                        cursor: isCurrentUserSuperAdmin ? 'text' : 'not-allowed',
                      }}
                    />
                    {isCurrentUserSuperAdmin && activeLocationIndex === 'mainProfile' && matchedLocations.length > 0 && (
                      <div
                        className="location-dropdown shadow-sm"
                        onMouseDown={event => event.stopPropagation()}
                        onClick={event => event.stopPropagation()}
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          backgroundColor: '#fff',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          maxHeight: '200px',
                          overflowY: 'auto',
                          zIndex: 1050,
                        }}
                      >
                        {matchedLocations.map((loc, idx) => (
                          <div
                            key={`${loc.label}-${idx}`}
                            className="location-dropdown-item text-dark"
                            style={{
                              padding: '8px 12px',
                              cursor: 'pointer',
                              backgroundColor: highlightedLocationIndex === idx ? '#f5f5f5' : 'transparent',
                            }}
                            onMouseDown={event => {
                              event.preventDefault();
                              event.stopPropagation();
                              selectLocation(loc);
                            }}
                            onClick={event => {
                              event.preventDefault();
                              event.stopPropagation();
                            }}
                          >
                            {loc.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {isCurrentUserSuperAdmin && requireMessage &&
                  (profileData.location === undefined || profileData.location === null || profileData.location === '') ? (
                    <span className="validation">{ERROR_MESSAGES}</span>
                  ) : (
                    ''
                  )}
                  {errors.location && <span className="validation">{errors.location}</span>}

                  <div className="button-group" style={{ width: '70%' }}>
                    <button type="button" className="profileBtn cancel" onClick={() => onClose(false)}>
                      Close
                    </button>
                    <button type="button" className="profileBtn save" onClick={handleSave}>
                      <i className="fa-solid fa-floppy-disk"></i> Save Changes
                    </button>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'settings' && (
              <div className="box b active">
                <div className="">
                  {/* Top buttons */}
                  {settingsView === 'initial' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                      {!isSSOUser && (
                        <button className="profileBtn" onClick={() => setSettingsView('changePassword')}>
                          Change Password
                        </button>
                      )}
                      {canManageAdminUsers && isCurrentUserSuperAdmin && (
                        <button
                          className="profileBtn"
                          onClick={() => {
                            setSettingsView('adminAccess');
                            handleGetMembers();
                          }}
                        >
                          Manage Admin Users
                        </button>
                      )}
                      <button
                        className="profileBtn"
                        onClick={() => {
                          window.open('/privacy-policy', '_blank');
                        }}
                      >
                        View Privacy Policy
                      </button>
                      <button
                        className="profileBtn"
                        onClick={() => {
                          window.open('/terms-of-service', '_blank');
                        }}
                      >
                        View Terms of Service
                      </button>
                      <button
                        onClick={() => {
                          setIsConfirmOpen(true);
                        }}
                        type="submit"
                        className="profileBtn save main-delet small-btn"
                      >
                        <i className="fa-solid fa-trash me-2"></i>
                        Deactivate Account
                      </button>
                    </div>
                  )}

                  {/* Change Password Form */}
                  {settingsView === 'changePassword' && (
                    <form
                      className="profile-form"
                      onSubmit={event => {
                        event.preventDefault();
                        handleUpdatePassword();
                      }}
                    >
                      <div>
                        <h4 className="mb-1">Change Password</h4>
                        <p className="text-muted font-13 mb-2">
                          Enter your current password and choose a new password for this university account.
                        </p>
                      </div>
                      {[
                        { label: 'Password', name: 'password' },
                        { label: 'New Password', name: 'newPassword' },
                        { label: 'Retype New Password', name: 'retypePassword' },
                      ].map((field, index) => (
                        <div key={index}>
                          <div className="form-group d-flex justify-content-between align-items-center">
                            <label>{field.label}</label>
                          </div>
                          <div className="form-field position-relative">
                            <input
                              type={showPassword[field.name] ? 'text' : 'password'}
                              style={{
                                width: '100%',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '8px',
                                height: '38px',
                              }}
                              name={field.name}
                              autoComplete="new-password"
                              value={settingsData[field.name]}
                              onChange={handleSettingsChange}
                              placeholder={
                                field.name === 'password'
                                  ? 'Enter Current Password'
                                  : field.name === 'newPassword'
                                    ? 'Enter New Password'
                                    : 'Retype New Password'
                              }
                            />
                            <span
                              onClick={() => toggleVisibility(field.name)}
                              style={{
                                cursor: 'pointer',
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                fontSize: '16px',
                                color: '#007bff',
                              }}
                            >
                              {!showPassword[field.name] ? <i className="fa-solid fa-eye-slash"></i> : <i className="fa-solid fa-eye"></i>}
                            </span>
                          </div>
                          {errors[field.name] && <div className="text-danger font-12 mt-1">{errors[field.name]}</div>}
                          {field.name === 'newPassword' && settingsData.newPassword && (
                            <div style={{ marginTop: '8px' }}>
                              <div
                                style={{
                                  height: '5px',
                                  background: '#e9ecef',
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                }}
                              >
                                <div
                                  style={{
                                    width: getStrengthWidth(passwordStrength),
                                    height: '100%',
                                    background: getStrengthColor(passwordStrength),
                                    transition: 'width 0.3s',
                                  }}
                                ></div>
                              </div>
                              <small
                                style={{
                                  color: getStrengthColor(passwordStrength),
                                  fontWeight: 500,
                                }}
                              >
                                Strength: {passwordStrength}
                              </small>
                              {!errors.newPassword && (
                                <ul className="text-danger mt-2 mb-0 ps-3" style={{ fontSize: '12px' }}>
                                  {settingsData.newPassword.length < 8 && <li>Password must be at least 8 characters long.</li>}
                                  {!/[A-Z]/.test(settingsData.newPassword) && <li>Password must contain at least one uppercase letter.</li>}
                                  {!/[a-z]/.test(settingsData.newPassword) && <li>Password must contain at least one lowercase letter.</li>}
                                  {!/\W/.test(settingsData.newPassword) && <li>Password must contain at least one special character.</li>}
                                </ul>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                      {Error && <div className="text-danger text-center font-12 mt-1">{Error}</div>}
                      <div className="d-flex justify-content-start gap-2 mb-1 mt-2" style={{ width: '100%' }}>
                        <button
                          type="submit"
                          className="profileBtn save small-btn"
                          style={{
                            width: '100%',
                            minWidth: 0,
                            flex: '1 1 0',
                            height: '38px',
                            padding: '6px 12px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          <i className="fa-solid fa-circle-check me-1"></i>
                          Update Password
                        </button>
                        <button
                          type="button"
                          className="profileBtn cancel small-btn"
                          style={{
                            width: '100%',
                            minWidth: 0,
                            flex: '1 1 0',
                            height: '38px',
                            padding: '6px 12px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            whiteSpace: 'nowrap',
                          }}
                          onClick={() => setSettingsView('initial')}
                        >
                          Back
                        </button>
                      </div>
                    </form>
                  )}

                  {/* Admin Access Section */}
                  {settingsView === 'adminAccess' && canManageAdminUsers && isCurrentUserSuperAdmin && (
                    <>
                      <h4 style={{ marginBottom: '12px' }}>Current Admins</h4>
                      <div style={{ width: '100%', marginBottom: '0px' }}>
                        {!superAdmin && members.length === 0 ? (
                          <div style={{ textAlign: 'center', padding: '12px', color: '#6c757d' }}>No admins found.</div>
                        ) : (
                          <>
                            {superAdmin && (
                              <div
                                key="super-admin"
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '0px 8px',
                                  border: '1px solid #eee',
                                }}
                              >
                                <span style={{ fontWeight: 500 }}>{superAdmin}</span>
                                <span className="save main-delet small-btn" style={{ color: 'gray' }}>
                                  (Super Admin)
                                </span>
                              </div>
                            )}
                            {members.map(member => (
                              <div
                                key={member.member_id}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '0px 8px',
                                  border: '1px solid #eee',
                                }}
                              >
                                <span style={{ fontWeight: 500 }}>{member.name}</span>
                                <button
                                  className="profileBtn save main-delet small-btn"
                                  style={{ border: 'none', flex: 'none' }}
                                  onClick={() => handleRemoveAdmin(member.member_id)}
                                >
                                  Remove Admin Access
                                </button>
                              </div>
                            ))}
                          </>
                        )}
                      </div>
                      <form
                        style={{ marginTop: '24px' }}
                        onSubmit={event => {
                          event.preventDefault();
                          handleAddAdmin();
                        }}
                      >
                        <h5>Add More Admins</h5>
                        <div>
                          <div className="form-group">
                            <label>New Admin Full Name</label>
                          </div>
                          <div className="form-field">
                            <input
                              type="text"
                              name="fullName"
                              value={newAdmin.fullName}
                              onChange={handleNewAdminChange}
                              placeholder="Enter full name"
                              style={{
                                width: '100%',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '8px',
                                height: '38px',
                              }}
                            />
                            {errors.newAdminFullName && <div className="text-danger font-12 mt-1">{errors.newAdminFullName}</div>}
                          </div>
                        </div>
                        <div style={{ marginTop: '12px' }}>
                          <div className="form-group">
                            <label>New Admin Email</label>
                          </div>
                          <div className="form-field">
                            <input
                              type="email"
                              name="email"
                              value={newAdmin.email}
                              onChange={handleNewAdminChange}
                              placeholder="Enter email"
                              style={{
                                width: '100%',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                padding: '8px',
                                height: '38px',
                              }}
                            />
                            {errors.newAdminEmail && <div className="text-danger font-12 mt-1">{errors.newAdminEmail}</div>}
                          </div>
                        </div>
                        <div className="button-group" style={{ width: '100%', marginTop: '16px' }}>
                          <button type="button" className="profileBtn cancel" onClick={() => setSettingsView('initial')}>
                            Back
                          </button>
                          <button type="submit" className="profileBtn save">
                            <i className="fa-solid fa-plus me-2"></i> Add New Admin
                          </button>
                        </div>
                      </form>
                    </>
                  )}

                  {settingsView === 'adminAccess' && (!canManageAdminUsers || !isCurrentUserSuperAdmin) && (
                    <>
                      <div className="text-danger font-12 mt-2 mb-3">You are not authorized to manage admin users.</div>
                      <button type="button" className="profileBtn cancel small-btn" onClick={() => setSettingsView('initial')}>
                        Back
                      </button>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <SuccessModel
          isOpen={isSuccessOpen}
          title="Success!"
          message={successMessage || (activeTab === 'profile' ? 'Profile updated successfully!' : 'Password updated successfully!')}
          buttonText="OK"
          onClose={() => {
            handleGetOrganisationDetails();
            setSuccessMessage('');
            setIsSuccessOpen(false);
            setIsProfileUpdate(true);
            onClose();
          }}
        />
        {isImagePopupOpen && (
          <ImageUploadEditModal
            image={image}
            onClose={() => setIsImagePopupOpen(false)}
            isAddUpdateDone={isAddUpdateDone}
            setAddUpdateDone={setAddUpdateDone}
            Type={'Profile'}
          />
        )}
        {IsViewImage && <ViewImagePopup image={image} onClose={() => setIsViewImage(false)} />}
        <ConfirmationModal
          isOpen={isConfirmOpen}
          title="Alert!"
          message={deactivateAccountMessage}
          confirmText="OK"
          subMessage={deactivateAccountSubMessage}
          action="Warning"
          onConfirm={() => setIsConfirmOpen(false)}
          onCancel={() => setIsConfirmOpen(false)}
          hideCancelBtn={true}
        />
        <ConfirmationModal
          isOpen={isRemoveAdminConfirmOpen}
          title="Confirm Removal"
          message="Are you sure you want to remove this admin's access?"
          confirmText="Remove"
          action="Delete"
          onConfirm={handleConfirmRemoveAdmin}
          onCancel={() => setRemoveAdminConfirmOpen(false)}
        />
        <ConfirmationModal
          isOpen={isErrorPopupOpen}
          title="Error"
          message={errorPopupMessage}
          confirmText="OK"
          action="Error"
          onConfirm={() => setIsErrorPopupOpen(false)}
          hideCancelBtn={true}
          subMessage=""
        />
      </div>
    </>
  );
};

export default ProfileAndSettingPopUp;
